@if (!isAdminRoute() && isUserActive()) {
  <div>
    <div class="quarter-container">
      @if (isUserActive()) {
        <mat-form-field class="top">
          <mat-label>Org</mat-label>
          <mat-select [(value)]="selectedOQContext.org" (opened)="setViewToSelected()" #orgSelector>
            @for (org of organizations; track org) {
              <mat-option (click)="selectedOrgChanged(org)" (keydown.enter)="selectedOrgChanged(org)" [value]="org">
                {{org.orgCode}} - {{org.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (isUserActive()) {
        <mat-form-field class="middle">
          <mat-label>Current Quarter</mat-label>
          <mat-select [(value)]="selectedOQContext.qtr">
            @for (quarter of quarters; track quarter) {
              <mat-option (click)="selectedQuarterChanged(quarter)" (keydown.enter)="selectedQuarterChanged(quarter)" [value]=quarter>
                {{quarter.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (isUserActive()) {
        <mat-form-field class="bottom">
          <mat-label>Currency</mat-label>
          <input matInput readonly value="{{ selectedOQContext.org?.defaultCurrency}}" />
        </mat-form-field>
      }
    </div>
  </div>
}
